import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { Formik, Form } from 'formik';
import FormInput from '../form/FormInput';
import ExpandableSection from '../common/ExpandableSection';

export const TextSearchHeader = (props) => (
  <Fragment>
    <div className="col">
      <span className="icon-search">&#xe915;</span>
      <FormInput
        name="searchText"
        placeholder={props.placeholder || "Search text"} />
    </div>
  </Fragment>
);

const SearchForm = ({ children, searchHeader: SearchHeader, toggleAction, onSubmit, ...props }) => (
  <Formik
    {...props}
    onSubmit={(values, { setSubmitting, setErrors, setStatus }) => {
      Promise.resolve(onSubmit(values))
        .then(() => {
          setSubmitting(false)
          setStatus('submitted')
        })
        .catch(error => {
          setSubmitting(false)
          setErrors({ form: error })
        })
    }}
    render={({
      handleSubmit,
      handleReset,
      isSubmitting,
      touched,
      dirty
    }) => (
        <Form>
          <fieldset className="search-header">
            <SearchHeader />
            <div className="buttons">
              <button className="submit" type="submit" onClick={handleSubmit} disabled={!touched || isSubmitting}><span className="icon-search">&#xe915;</span>Search</button>
              <button className="clear" type="button" onClick={handleReset} disabled={!touched || isSubmitting}>Clear</button>
              <a className="icon-advanced" title="Advanced" data-tooltip="Advanced" onClick={toggleAction}>&#xe916;</a>
            </div>
          </fieldset>
          <fieldset className="search-box">
            {children}
          </fieldset>
        </Form>
      )}
  />
);

export default ExpandableSection(SearchForm);



// WEBPACK FOOTER //
// ./src/components/searchForm/index.js